__turbopack_context__.v({
  "card-wrapper": "style-module-scss-module__SYSSzq__card-wrapper",
  "check-wrapper": "style-module-scss-module__SYSSzq__check-wrapper",
  "compact": "style-module-scss-module__SYSSzq__compact",
  "exp-theme": "style-module-scss-module__SYSSzq__exp-theme",
  "heading": "style-module-scss-module__SYSSzq__heading",
  "house-image-wrapper": "style-module-scss-module__SYSSzq__house-image-wrapper",
  "inner-wrapper": "style-module-scss-module__SYSSzq__inner-wrapper",
  "mobile-card-wrapper": "style-module-scss-module__SYSSzq__mobile-card-wrapper",
});
